import formatDate from '@/utils/formatDate'

export const SAVED_LISTS_COLUMNS = [
  {
    name: 'name',
    label: 'Name',
    align: 'left',
    field: 'name',
    sortable: true,
    style: 'width: 40%'
  },
  {
    name: 'creator',
    label: 'User',
    align: 'left',
    field: 'creator',
    sortable: true,
    style: 'width: 15%'
  },
  {
    name: 'created',
    label: 'Created',
    align: 'left',
    field: 'createdDate',
    format: val => formatDate(val),
    sortable: true,
    style: 'width: 15%'
  },
  {
    name: 'lastEdited',
    label: 'Last Edited',
    align: 'left',
    field: 'modifiedDate',
    format: val => formatDate(val),
    sortable: true,
    style: 'width: 15%'
  },
  {
    name: 'actions',
    label: '',
    align: 'center',
    field: 'actions',
    sortable: false,
    style: 'width: 10%'
  },
  {
    name: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sortable: true,
    style: 'width: 20%'
  }
]

export const ADD_NEW_CONFIGS_TO_SAVED_LISTS_TABLE_COLUMNS = [
  {
    name: 'add',
    label: 'Add',
    align: 'middle',
    field: 'add',
    showSortElement: false,
    sortDirection: 'ASC',
    style: 'width: 15%; white-space: normal; text-align-last: center;',
    sortable: false
  },
  {
    name: 'name',
    label: 'List name',
    align: 'left',
    field: 'name',
    showSortElement: false,
    sortDirection: 'ASC',
    style: 'width: 60%; white-space: normal; overflow-wrap: anywhere',
    sortable: false
  },
  {
    name: 'modifiedDate',
    label: 'Last edited',
    align: 'center',
    field: ({ modifiedDate } = {}) => formatDate(modifiedDate) || '',
    showSortElement: true,
    sortDirection: 'DESC',
    style: 'width: 25%; white-space: normal',
    sortable: false
  }
]

export const REMOVE_CONFIGS_FROM_SAVED_LISTS_TABLE_COLUMNS = [
  {
    name: 'add',
    label: '',
    align: 'middle',
    field: 'add',
    showSortElement: false,
    sortDirection: 'ASC',
    style: 'width: 5%; white-space: normal; text-align-last: center;',
    sortable: false
  },
  {
    name: 'name',
    label: '',
    align: 'left',
    field: 'name',
    showSortElement: false,
    sortDirection: 'ASC',
    style: 'width: 95%; white-space: normal; overflow-wrap: anywhere',
    sortable: false
  }
]

export const SAVED_LISTS_STATUS = Object.freeze({
  NEW: {
    color: 'info',
    key: 'NEW',
    label: 'NEW'
  },
  UPDATED: {
    color: 'info',
    key: 'UPDATED',
    label: 'UPDATED'

  },
  READY_TO_DOWNLOAD: {
    color: 'success',
    key: 'READY_TO_DOWNLOAD',
    label: 'READY TO DOWNLOAD'

  },
  EXPORTED: {
    color: 'default',
    key: 'EXPORTED',
    label: 'EXPORTED'
  },
  IN_PROGRESS: {
    color: 'warning',
    key: 'IN_PROGRESS',
    label: 'IN PROGRESS'

  },
  FAILED: {
    color: 'error',
    key: 'FAILED',
    label: 'FAILED'

  }
})

export const SAVED_LISTS_EXPORT_OPTIONS_PROVIDER = 'PAC_SAVED_LISTS_EXPORT_OPTIONS'
